import { NodeTypes } from "../components/SlateEditor/slateTypes";
import type { Message } from "../hooks/reactQueryHooks/useRequests";

export const getMessagesList = (message: Message) => {
  if (message.role === "assistant" && message.toolCalls) {
    const parsedToolCalls = JSON.parse(message.toolCalls);
    const calls = parsedToolCalls.map((call: any) => {
      return {
        type: NodeTypes.CODE_LINE,
        children: [
          { text: `${call.function.name} (${call.function.arguments})` },
        ],
      };
    });
    return [
      {
        type: NodeTypes.BLOCK_CODE,
        children: calls,
      },
    ];
  }

  if (message.role === "tool") {
    return [
      {
        type: NodeTypes.BLOCK_CODE,
        children: [
          {
            type: NodeTypes.CODE_LINE,
            children: [{ text: message.content.replace(/\\"/g, "") }],
          },
        ],
      },
    ];
  }

  return message.content
    ? [{ type: "paragraph", children: [{ text: message.content }] }]
    : [
        {
          type: "paragraph",
          children: [{ text: "No content", emphasis: true }],
        },
      ];
};
